'use client';

import { c as _c } from "react/compiler-runtime";
import { Grid, TextLink } from '@petsmart-ui/sparky';
import { AccountDrawerType, usePageLayout } from '@libs/common-next';
export type ForgotPasswordCtaProps = {
  componentClassname?: string;
  webUrl?: string;
  actionText?: string;
};
export function ForgotPasswordCta(t0) {
  const $ = _c(10);
  const {
    componentClassname,
    webUrl,
    actionText
  } = t0;
  const {
    openAccountDrawer
  } = usePageLayout();
  const t1 = `${componentClassname}__forgot-password`;
  const t2 = webUrl ?? "#";
  let t3;
  if ($[0] !== openAccountDrawer || $[1] !== webUrl) {
    t3 = event => {
      if (!webUrl) {
        event.preventDefault();
        openAccountDrawer(AccountDrawerType.FORGOT_PASSWORD);
      }
    };
    $[0] = openAccountDrawer;
    $[1] = webUrl;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = actionText ?? "Forgot password?";
  let t5;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = <TextLink href={t2} data-testid="forgot-password-link" onClick={t3}>{t4}</TextLink>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t5) {
    t6 = <Grid.Item className={t1}>{t5}</Grid.Item>;
    $[7] = t1;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}